<script>
  import { benefits, benefitsDef, currentPageIndex, layout } from "../store.js";
  export let benefit;
  export let advance_page = true;

  import { confettiWin } from "../helpers/confetti.js";
  import { playSfx } from "../helpers/sfx.js";
  import { tick } from "svelte";

  import Button from "./Button.svelte";

  let ben = $benefitsDef[benefit];

  async function collectBenefit() {
    $benefits.add(benefit);
    $benefits = $benefits;
    if (advance_page && layout === "fullscreen") $currentPageIndex += 1;

    if (ben.show_confetti) {
      await tick();
      confettiWin();
    }

    if (ben.play_sound) {
      playSfx(ben.play_sound);
    }
  }
</script>

<div class="locked-benefit">
  <Button onClick={collectBenefit} disabled={$benefits.has(benefit)}
    >Weiter</Button
  >
</div>

<style>
  .locked-benefit {
    text-align: center;
  }
</style>
